/* 
 * Vue js extend
 */

module.exports = ( Vue ) => { 

	Vue.prototype.user = false;

	Vue.prototype.setUser = function( usr ) {
		if( typeof usr == 'object' ) {
			Vue.prototype.user = usr;
		}
	}

	Vue.prototype.planURL = function() {
		if( this.user ) {
			return this.url('profile');
		} else {
			return this.url('register');
		}
	}

	Vue.prototype.ucFirst = function( s ) {
	  	if (typeof s !== 'string') {
	  		return '';
		}

		return s.charAt(0).toUpperCase() + s.slice(1);
	}

	Vue.prototype.loginRedirect = function() {
		location.href = '/login';
	}

	Vue.prototype.play = function( v ) {
		bus.$emit('play-video',v);
	}
	
	Vue.prototype.url = function( to ) {
		var locals = ['ofmdb.com','localhost','82.180.139.192'];

		if( locals.includes(location.hostname) ) {
			var base = "/";
		} else {
			var base = 'https://ofmdb.com/';
		}

		if( typeof to == 'undefined' ) {
			return base;
		} else {
			return base + to;
		}
	}

	
}
